import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["popoverUse", "size"];
import { useTheme } from 'foundations-theming/utils';
import { CloseButton } from '../CloseButton/CloseButton';
import { toShorthandSize } from '../../utils/tShirtSizes';
import { PopoverCloseButtonProvider } from './PopoverCloseButtonContext';
import { jsx as _jsx } from "react/jsx-runtime";
const CLOSE_BUTTON_USE_COLOR_MAP = {
  default: 'icon-core-subtle',
  shepherd: 'icon-inverse-default',
  longform: 'icon-core-subtle',
  tooltip: 'icon-core-on-fill-default',
  'tooltip-danger': 'icon-core-on-fill-default',
  unstyled: 'icon-core-subtle'
};
export const PopoverCloseButton = _ref => {
  let {
      popoverUse = 'default',
      size = 'md'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  return /*#__PURE__*/_jsx(PopoverCloseButtonProvider, {
    closeButtonStyleOverrides: {
      position: 'relative',
      marginInlineStart: size === 'sm' ? theme.space['200'] : theme.space['300'],
      insetInlineStart: '0px',
      insetInlineEnd: '0px',
      insetBlockStart: size === 'sm' ? '0px' : '4px'
    },
    children: /*#__PURE__*/_jsx(CloseButton, Object.assign({
      color: CLOSE_BUTTON_USE_COLOR_MAP[popoverUse],
      size: toShorthandSize(popoverUse === 'longform' ? 'sm' : size)
    }, rest))
  });
};
PopoverCloseButton.displayName = 'PopoverCloseButton';